
@switch (field.type) {
  @case (sectionUri) {
    @if (!field.hidden) {
      <div animate.enter="fade-in" class="prose prose-sm max-w-full mt-8">
            <h2 [ngClass]="{
                    'uppercase': field.textTransform === 'UPPERCASE',
                    'lowercase': field.textTransform === 'LOWERCASE'
                }">{{ field.label | localize }}</h2>
        @if (field.hint) {
          <p>{{ field.hint | localize }}</p>
        }
      </div>
    }
  }
  @case (subsectionUri) {
    @if (!field.hidden) {
      <div animate.enter="fade-in" class="prose prose-sm max-w-full mt-8">
            <h3 [ngClass]="{
                    'uppercase': field.textTransform === 'UPPERCASE',
                    'lowercase': field.textTransform === 'LOWERCASE'
                }">{{ field.label | localize }}</h3>
        @if (field.hint) {
          <p>{{ field.hint | localize }}</p>
        }
      </div>
    }
  }
  @default {
    @if (!field.hidden) {
<div animate.enter="fade-in" [innerHtml]="field.label | localize | safeHtml" [ngClass]="{
                    'uppercase': field.textTransform === 'UPPERCASE',
                    'lowercase': field.textTransform === 'LOWERCASE'
                }"></div>
    }
  }
}
